export default "__VITE_ASSET__DDOFJRr8__"